import { render, staticRenderFns } from "./alarm-table.vue?vue&type=template&id=effb264a&"
import script from "./alarm-table.vue?vue&type=script&lang=js&"
export * from "./alarm-table.vue?vue&type=script&lang=js&"
import style0 from "./alarm-table.vue?vue&type=style&index=0&id=effb264a&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports